import { render, staticRenderFns } from "./FavoriteToggle.vue?vue&type=template&id=60fefd16&scoped=true&"
import script from "./FavoriteToggle.vue?vue&type=script&lang=js&"
export * from "./FavoriteToggle.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteToggle.vue?vue&type=style&index=0&id=60fefd16&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fefd16",
  null
  
)

export default component.exports